import { render } from "./AboutCards.vue?vue&type=template&id=3ceb1d0b"
import script from "./AboutCards.vue?vue&type=script&lang=js"
export * from "./AboutCards.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__